'use client';

import { getClientLocaleFromClientCookie, getClientLocaleFromTheBrowser } from '@/src/lib/dictionary/utils.ts';
import { formatDate } from '@/src/lib/date/business/format-date.ts';

export function formatDateClient(date: string): string {
  let language: string | undefined = getClientLocaleFromTheBrowser();

  if (!language) {
    language = getClientLocaleFromClientCookie();
  }

  return formatDate(date, language);
}
